import React from 'react';

function Footer() {
  const handleEmailClick = () => {
    window.location.href = 'mailto:support@ihu.com';
  };

  const handlePhoneClick = () => {
    window.location.href = 'tel:+917439213152';
  };

  const handleAddressClick = () => {
    window.open('https://www.google.com/maps?q=956, Kalikapur Road, Purbanchal, Kolkata 700078', '_blank');
  };

  const callNumber = () => {
    window.location.href = 'tel:+917439213152';
  };

  return (
    <div className="container">
      <footer>
        <div className="footer-container">
          <div className="footer-column">
            <h4 className="fade-out fade-in  ">Indian Health Unit</h4>
            <p className="fade-out fade-in  ">
              IHU (Indian Health Unit) is a trusted provider of home healthcare services across India. We specialize in offering
              doctor visits at home, medical technologists on call, ambulance services, wheelchair rentals, virtual
              medical consultations, and home-based diagnostic testing.
            </p>
          </div>
          <div className="footer-column">
            <h4 className="fade-out fade-in  ">Our Services</h4>
            <ul>
              <li className="fade-out fade-in  "><a href="#">Virtual Medical Consultation</a></li>
              <li className="fade-out fade-in  "><a href="#">Home Doctor Visits</a></li>
              <li className="fade-out fade-in  "><a href="#">Emergency Ambulance Assistance</a></li>
              <li className="fade-out fade-in  "><a href="#">Rental Medical Equipment</a></li>
              <li className="fade-out fade-in  "><a href="#">At-Home Medical Treatments</a></li>
              <li className="fade-out fade-in  "><a href="#">Physiotherapy Sessions</a></li>
              <li className="fade-out fade-in  "><a href="#">Professional Nursing Support</a></li>
            </ul>
          </div>
          <div className="footer-column">
            <h4 className="fade-out fade-in  ">Quick Links</h4>
            <ul>
              <li className="fade-out fade-in  "><a href="#">Privacy & Data Protection</a></li>
              <li className="fade-out fade-in  "><a href="#">Terms of Service</a></li>
            </ul>
          </div>
          <div id="contact" className="footer-column">
            <h4 className="fade-out fade-in  ">Get in Touch</h4>
            <div className="contact-info">
              <button className="contact-button btn-null fade-out fade-in  " onClick={handleEmailClick}>
                <strong>Email:</strong> support@ihu.co.in
              </button>
              <button className="contact-button btn-null fade-out fade-in  " onClick={handlePhoneClick}>
                <strong>Phone:</strong> +91 7439213152
              </button>
              <button className="contact-button btn-null fade-out fade-in  " onClick={handleAddressClick}>
                <strong>Address:</strong> 956, Kalikapur Road, Purbanchal, Kolkata 700078
              </button>
            </div>
            <div className="map-container">
              <iframe
                className="fade-out fade-in  "
                src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d13131.901845830127!2d88.3455361192684!3d22.491279200000003!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x0%3A0x0!2zMjLCsDI5JzI4LjYiTiA4OMKwMjAnMTQuNyJF!5e0!3m2!1sen!2sin!4v1672048945601!5m2!1sen!2sin"
                allowFullScreen=""
                loading="lazy"
                title="Map"
              ></iframe>
            </div>
          </div>
        </div>

        <p className="copyright">
          &copy; 2025 All Rights Reserved | Design by <a target="_blank" href="https://www.dignexus.com/">Dignexus</a>
        </p>

        <a href="https://wa.me/917439213152" className="whatsapp-float" target="_blank" rel="noopener noreferrer">
          <i className="fab fa-whatsapp"></i>
        </a>

        <button onClick={callNumber} className="btn-null call-float">
          <i className="fa-solid fa-phone-volume"></i>
        </button>
      </footer>
    </div>
  );
}

export default Footer;
